module.exports = __webpack_public_path__ + "img/across back.8cec9862.png";